/**
 *  Component: Add to Slack Button
 */
import React from 'react';

import styled from 'styled-components';

import { endpoints } from 'constants/endpoints';

const ConnectorLine = () => (
  <Container>
    <a href={endpoints.plugins.slack.auth} target="_blank" rel="noreferrer">
      <img
        alt="Add to Slack"
        height="40"
        width="139"
        src="https://platform.slack-edge.com/img/add_to_slack.png"
        srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
      />
    </a>
  </Container>
);

const Container = styled.div`
  margin-top: 1rem;
`;

export default ConnectorLine;
